import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'py-tiny-multiple-cart-badge',
  templateUrl: './tiny-multiple-cart-badge.component.html',
  styleUrls: ['./tiny-multiple-cart-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TinyMultipleCartBadgeComponent {
  @Input() numberOfEntries: number;
}
